import packageIconBronze from 'assets/package-assets/package-c84b31.svg';
import packageIconGold from 'assets/package-assets/package-eba33b.svg';
import packageIconSilver from 'assets/package-assets/package-64748b.svg';
import { getPackageThemeByType, PackageThemeKey } from 'features/cashier/services/package-theme';
import { ICustomerServicePackage } from 'features/cashier/services/types/customer-service-package';
import { Calendar } from 'lucide-react';
import { PackageRow } from './styles';

const PACKAGE_ICON: Record<PackageThemeKey, string> = {
  bronze: packageIconBronze,
  silver: packageIconSilver,
  gold: packageIconGold,
};

interface IPackageDetailRowProps {
  data: ICustomerServicePackage;
  /** số buổi còn thêm được vào ticket, đã trừ dòng đang có */
  usableQuantity: number;
  value: number;
  onChange: (quantity: number) => void;
}

/** Một gói trong modal: tiến độ buổi còn lại và stepper chọn số buổi dùng hôm nay */
const PackageDetailRow = ({ data, usableQuantity, value, onChange }: IPackageDetailRowProps) => {
  const themeKey = getPackageThemeByType(data.type);
  const total = data.totalQuantity || 0;
  const remaining = data.remainingQuantity || 0;
  const percent = total > 0 ? Math.min((remaining / total) * 100, 100) : 0;

  return (
    <PackageRow themeKey={themeKey}>
      <div className='tier-side'>
        <img src={PACKAGE_ICON[themeKey]} alt='' />
        <span className='tier-badge'>{data.tierName}</span>
      </div>

      <div className='program-side'>
        <p className='program-name'>{data.programName}</p>
        <p className='program-description'>{data.description}</p>
        <span className='expires'>
          <Calendar size={14} />
          Expires on: {data.expiredAt}
        </span>
      </div>

      <div className='remaining-side'>
        <p className='remaining-value'>{remaining}</p>
        <p className='remaining-label'>Sessions remaining</p>
        <div className='progress'>
          <div className='progress-value' style={{ width: `${percent}%` }} />
        </div>
        <p className='total-label'>of {total} total</p>
      </div>

      <div className='use-side'>
        <p className='use-label'>Use today</p>
        <div className='stepper'>
          <button type='button' className='stepper-button' disabled={value <= 0} onClick={() => onChange(value - 1)}>
            −
          </button>
          <span className='stepper-value'>{value}</span>
          <button
            type='button'
            className='stepper-button'
            disabled={value >= usableQuantity}
            onClick={() => onChange(value + 1)}
          >
            +
          </button>
        </div>
        <p className='maximum-label'>Maximum {usableQuantity}</p>
      </div>
    </PackageRow>
  );
};

export default PackageDetailRow;
